"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForceElementSizeFeature = void 0;
var _FeatureBuilder = _interopRequireDefault(require("../FeatureBuilder"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

/* babel-plugin-inline-import './ForceElementSizeFeature.webjs' */
var script = "function ForceElementSizeFeature(context) {\n  var options = context.options || {};\n  var widthValue = options.widthValue || 'auto';\n  var heightValue = options.heightValue || 'auto';\n  var forceWidth = options.forceWidth !== false;\n  var forceHeight = options.forceHeight !== false;\n  var target = options.target;\n  var shouldThrowWhenNotFound = options.shouldThrowWhenNotFound === true;\n  if (!target || (typeof target !== 'string' && typeof target !== 'object')) {\n    throw new Error('Missing or wrong type for required target option');\n  }\n  var element = context.utils.getDOMSelection(target);\n  if (element) {\n    if (forceWidth) {\n      element.style.width = widthValue;\n    }\n    if (forceHeight) {\n      element.style.height = heightValue;\n    }\n  } else if (shouldThrowWhenNotFound) {\n    throw new Error(\n      \"Couldn't find an element for target \" + JSON.stringify(target)\n    );\n  }\n}\n";
var defaultOptions = {
  target: 'body',
  forceHeight: true,
  forceWidth: true,
  widthValue: 'auto',
  heightValue: 'auto',
  shouldThrowWhenNotFound: false
};
/**
 * This feature sets element size programmatically and only once, when
 * {@link https://developer.mozilla.org/fr/docs/Web/Events/DOMContentLoaded | DOMContentLoaded}
 * has been fired. See {@link ForceElementSizeOptions} for customization.
 *
 * @example
 * ```ts
 * const Webshell = makeWebshell(
 *   WebView,
 *   new ForceElementSizeFeature({
 *     target: { id: "blog-content" },
 *     heightValue: 500,
 *     forceWidth: false,
 *   })
 * );
 * ```
 *
 * @public
 */

var ForceElementSizeFeature = new _FeatureBuilder["default"]({
  script: script,
  defaultOptions: defaultOptions,
  identifier: 'org.formidable-webview/webshell.force-element-size'
}).build();
exports.ForceElementSizeFeature = ForceElementSizeFeature;